import React, { useEffect, useState } from 'react';
import Button from 'react-bootstrap/Button';
import Card from 'react-bootstrap/Card';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Alert from 'react-bootstrap/Alert';
import ListGroup from 'react-bootstrap/ListGroup';
import axios from 'axios';
import OwlCarousel from 'react-owl-carousel';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';
import { Link, useLocation, useParams } from 'react-router-dom';

// Content Loader
import DetailsLoader from '../loader/DetailsLoader';

import { getUserDataFromLS } from '../../helpers/utility';

import { getRentDetails, addToFavRent } from '../api/Api';
import ButtonGoBackRoute from '../button/ButtonGoBackRoute';

// Share
import {
    EmailShareButton,
    FacebookShareButton,
    GabShareButton,
    HatenaShareButton,
    InstapaperShareButton,
    LineShareButton,
    LinkedinShareButton,
    LivejournalShareButton,
    MailruShareButton,
    OKShareButton,
    PinterestShareButton,
    PocketShareButton,
    RedditShareButton,
    TelegramShareButton,
    TumblrShareButton,
    TwitterShareButton,
    ViberShareButton,
    VKShareButton,
    WhatsappShareButton,
    WorkplaceShareButton,
  } from "react-share";
  import {
    EmailIcon,
    FacebookIcon,
    FacebookMessengerIcon,
    GabIcon,
    HatenaIcon,
    InstapaperIcon,
    LineIcon,
    LinkedinIcon,
    LivejournalIcon,
    MailruIcon,
    OKIcon,
    PinterestIcon,
    PocketIcon,
    RedditIcon,
    TelegramIcon,
    TumblrIcon,
    TwitterIcon,
    ViberIcon,
    VKIcon,
    WeiboIcon,
    WhatsappIcon,
    WorkplaceIcon,
    XIcon,
  } from "react-share";
import { Spinner } from 'react-bootstrap';

function RentDetails({isInIframe}) {

  const[rentDetails, setRentDetails] = useState('');
  const[favRentStatus, setFavRentStatus] = useState('');
  const[rentTitle, setRentTitle] = useState('');

  const[shareURL, setShareURL] = useState('');

  const[isBackBtnActive, setIsBackBtnActive] = useState(false);

  const { rentid, title } = useParams();

  const options = {
    loop:false,
    margin:10,
    nav:true,
    dots:true,
    responsive:{
        0:{
            items:1
        },
        600:{
            items:1
        },
        1000:{
            items:1
        }
    }
}

    const fetchRentDetails = () => {
        getRentDetails(getUserDataFromLS('userid'), rentid)
        .then((response) => {
            response.data.success === 1 && setRentDetails(response.data);
            setFavRentStatus(response.data.shortlisted)
        })
        .catch((error) => {
            console.error('API error:', error);
        });
    };

    const handleFavRent = (action) => {
        addToFavRent(getUserDataFromLS('userid'), rentid, action)
        .then((response) => {
            console.log(response.data)
            setFavRentStatus(response.data.bookmarkstatus);
        })
        .catch((error) => {
            console.error('API error:', error);
        });
    };

    const { pathname } = useLocation();
    const location = useLocation();
    

  useEffect(() => {
    // Side effect code goes here
    // It will run after the component renders
    fetchRentDetails();

    const params = new URLSearchParams(location.search);
    const iframeStatus = params.get('iframe');
    console.log(iframeStatus === 'true');

    iframeStatus === 'true' ?
    setIsBackBtnActive(false) :
    setIsBackBtnActive(true);

    setShareURL(
        // `https://baribodol.com/bn/rent/${rentid}/${title !== undefined && title.replace(/\//g, "-")}`
        `https://baribodol.com/bn/rent/${rentid}}`
    );

    // console.log(`https://baribodol.com/bn/rent/${rentid}/${title.replace(/\//g, "-")}`);
    
    // Return a cleanup function if needed
    return () => {
      // Cleanup code goes here
      // It will run when the component unmounts or when dependencies change
    };
  }, []);



  return (
    <>
        {/* {console.log('iframe: ',iFrame)} */}
        {isBackBtnActive === true &&
            <ButtonGoBackRoute targetPath="/" />
        }
        {rentDetails.data !== undefined ? (
        <>
        <Container fluid>
            <Row>
                <Col md={8} className="p-0">
                    <div className="d-flex justify-content-center">
                        <OwlCarousel className="owl-theme owl-rdgallery mb-2 mb-md-4 position-fixed" loop margin={10} nav {...options}>
                            {rentDetails.data[0].images.length > 0 ?
                                rentDetails.data[0].images.map(item => 
                                    <img className="img-fluid" src={item} alt="property"/>
                                ) :
                                <img className="img-fluid" src="https://baribodol.com/images/postimg/img-placeholder-2.png" alt="property"/>
                            }
                        </OwlCarousel>
                    </div>
                </Col>
                <Col md={4} className="p-0">
                    <div className="rent-details py-3 px-4">
                        {/* <h2 className="fs-12">পোস্ট দাতার তথ্য</h2> */}
                        <div className="d-md-flex mt-md-3 justify-content-between">
                            <div className="d-flex">
                                <img src={rentDetails.data[0].profilephoto} className="me-2 rent-user-avatar" alt="avatar"/>
                                <ul className="list-unstyled">
                                    <li><span className="rent-user-name fw-md">{rentDetails.data[0].contactname !== null ? rentDetails.data[0].contactname : '-' }</span></li>
                                    <li><span className="rent-user-phone text-light">{rentDetails.data[0].phone.slice(2)}</span></li>
                                </ul>
                            </div>

                            <div className="action-control d-md-block d-flex ">
                                {/* <Button variant="light" className="btn-sm me-2 flex-fill">
                                    <svg className="icon me-1" width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M17.5605 3.32812L16.5 4.38867L19.626 7.5H12.375C10.101 7.5 8.25 9.35025 8.25 11.625C8.25 13.8997 10.101 15.75 12.375 15.75H12.75V14.25H12.375C10.9275 14.25 9.75 13.0725 9.75 11.625C9.75 10.1775 10.9275 9 12.375 9H19.6289L16.5059 12.123L17.5664 13.1836L22.5 8.25L17.5605 3.32812ZM3.75 3.75V20.25H20.25V12.75L18.75 14.25V18.75H5.25V5.25H13.3901L14.8901 3.75H3.75Z" fill="black"/>
                                    </svg>
                                    <span>শেয়ার</span>
                                </Button> */}
                                {getUserDataFromLS('userid') !== null &&
                                    <Button variant="light" className="btn-sm flex-fill" onClick={()=> handleFavRent(favRentStatus === 1 ? 0 : 1)}>
                                        {favRentStatus === 0 ? 
                                            <svg className="icon me-1" width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M7.125 3.75C4.02246 3.75 1.5 6.30176 1.5 9.375C1.5 10.4473 1.98633 11.376 2.4375 12.0469C2.88867 12.7178 3.35156 13.1484 3.35156 13.1484L11.4609 21.2812L12 21.8203L12.5391 21.2812L20.6484 13.1484C20.6484 13.1484 22.5 11.5166 22.5 9.375C22.5 6.30176 19.9775 3.75 16.875 3.75C14.2998 3.75 12.6416 5.2998 12 5.95312C11.3584 5.2998 9.7002 3.75 7.125 3.75ZM7.125 5.25C9.36621 5.25 11.4375 7.42969 11.4375 7.42969L12 8.0625L12.5625 7.42969C12.5625 7.42969 14.6338 5.25 16.875 5.25C19.1572 5.25 21 7.12207 21 9.375C21 10.5322 19.5938 12.0938 19.5938 12.0938L12 19.6875L4.40625 12.0938C4.40625 12.0938 4.04297 11.7451 3.67969 11.2031C3.31641 10.6611 3 9.95508 3 9.375C3 7.12207 4.84277 5.25 7.125 5.25Z" fill="black"/>
                                            </svg> :
                                            <svg className="icon me-1" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 18 18" fill="none">
                                                <path d="M12.6562 2.8125C11.0295 2.8125 9.65981 3.82725 9 4.41788C8.34019 3.82725 6.9705 2.8125 5.34375 2.8125C3.01725 2.8125 1.125 4.70475 1.125 7.03125C1.125 8.48812 2.45531 9.81394 2.50875 9.86681L9 16.3581L15.4879 9.87019C15.5447 9.81394 16.875 8.48812 16.875 7.03125C16.875 4.70475 14.9828 2.8125 12.6562 2.8125Z" fill="#F14B5B"/>
                                            </svg>
                                        }
                                        <span>{favRentStatus === 0 ? "সেইভ" : "রিমুভ"}</span>
                                    </Button>
                                }
                            </div>

                            
                        </div>

                            <div>
                                <FacebookShareButton className="me-2" url={shareURL} children={
                                    <FacebookIcon size={32} round={true} />
                                } />
                                <TwitterShareButton className="me-2" url={shareURL} children={
                                    <TwitterIcon size={32} round={true} />
                                } />
                                <LinkedinShareButton className="me-2" url={shareURL} children={
                                    <LinkedinIcon size={32} round={true} />
                                } />
                                <WhatsappShareButton className="me-2" url={shareURL} children={
                                    <WhatsappIcon size={32} round={true} />
                                } />
                                <EmailShareButton className="me-2" url={shareURL} children={
                                    <EmailIcon size={32} round={true} />
                                } />
                            </div>

                        <hr className="mt-2 mb-4 bg-light" />

                        <h1 className="mb-3 mt-4">{rentDetails.data[0].title} {rentDetails.data[0].location}</h1>
                        <ul class="list-inline rent-meta">
                                <li class="list-inline-item mb-2">
                                    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 32 32"> <title>টাইপ</title> <path fill="#000000" d="M4 3h24v26h-11v-4h-2v4h-11v-26zM6 5v22h7v-4h6v4h7v-22h-20zM8 7h4v2h-4v-2zM14 7h4v2h-4v-2zM20 7h4v2h-4v-2zM8 11h4v2h-4v-2zM14 11h4v2h-4v-2zM20 11h4v2h-4v-2zM8 15h4v2h-4v-2zM14 15h4v2h-4v-2zM20 15h4v2h-4v-2zM8 19h4v2h-4v-2zM14 19h4v2h-4v-2zM20 19h4v2h-4v-2zM8 23h4v2h-4v-2zM20 23h4v2h-4v-2z"></path> </svg>
                                    <span class="text-dark">{rentDetails.data[0].type}</span>
                                </li>
                                <li class="list-inline-item mb-2">
                                    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 32 32"><title>বেড রুম</title><path fill="#000000" d="M6 6h20c1.645 0 3 1.355 3 3v6.781c0.61 0.551 1 1.34 1 2.219v9h-5v-2h-18v2h-5v-9c0-0.878 0.39-1.668 1-2.219v-6.781c0-1.645 1.355-3 3-3zM6 8c-0.555 0-1 0.445-1 1v6h2v-1c0-1.645 1.355-3 3-3h4c0.767 0 1.467 0.3 2 0.781 0.533-0.481 1.233-0.781 2-0.781h4c1.645 0 3 1.355 3 3v1h2v-6c0-0.555-0.445-1-1-1h-20zM10 13c-0.555 0-1 0.445-1 1v1h6v-1c0-0.555-0.445-1-1-1h-4zM18 13c-0.555 0-1 0.445-1 1v1h6v-1c0-0.555-0.445-1-1-1h-4zM5 17c-0.555 0-1 0.445-1 1v7h1v-2h22v2h1v-7c0-0.555-0.445-1-1-1h-22z"></path></svg>
                                    <span class="text-dark">{rentDetails.data[0].bedrooms}</span>
                                </li>
                                <li class="list-inline-item mb-2">
                                    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 1024 1024"><title>ওয়াস রুম</title><g id="icomoon-ignore"></g><path fill="#000000" d="M702.682 68.173h-209.047c-99.944 0-181.25 81.306-181.25 181.25v106.556c-120.799 17.614-213.876 121.877-213.876 247.492 0 20.017 16.226 36.25 36.25 36.25h427.75c20.024 0 36.25-16.234 36.25-36.25 0-125.614-93.073-229.879-213.876-247.492v-106.556c0-59.968 48.782-108.75 108.75-108.75h209.038c59.973 0 108.754 48.782 108.754 108.75v710.501c0 20.021 16.226 36.249 36.249 36.249s36.249-16.226 36.249-36.249v-710.501c0.008-99.944-81.308-181.25-181.242-181.25v0zM522.546 567.213h-347.815c16.781-80.621 88.379-141.376 173.91-141.376s157.129 60.755 173.91 141.376zM384.89 728.232v54.375c0 20.021-16.226 36.249-36.249 36.249s-36.25-16.226-36.25-36.249v-54.375c0-20.031 16.226-36.257 36.25-36.257s36.249 16.226 36.249 36.257zM384.457 905.555v54.375c0 20.021-16.226 36.249-36.25 36.249-20.016 0-36.249-16.226-36.249-36.249v-54.375c0-20.031 16.234-36.257 36.249-36.257 20.024 0 36.25 16.226 36.25 36.257zM242.521 728.232v54.375c0 20.021-16.234 36.249-36.25 36.249-20.024 0-36.25-16.226-36.25-36.249v-54.375c0-20.031 16.226-36.257 36.25-36.257 20.016 0 36.25 16.226 36.25 36.257zM242.093 905.555v54.375c0 20.021-16.226 36.249-36.25 36.249s-36.25-16.226-36.25-36.249v-54.375c0-20.031 16.226-36.257 36.25-36.257s36.25 16.226 36.25 36.257zM526.829 728.232v54.375c0 20.021-16.234 36.249-36.25 36.249-20.024 0-36.25-16.226-36.25-36.249v-54.375c0-20.031 16.226-36.257 36.25-36.257 20.016 0 36.25 16.226 36.25 36.257zM526.399 905.555v54.375c0 20.021-16.234 36.249-36.249 36.249-20.024 0-36.25-16.226-36.25-36.249v-54.375c0-20.031 16.226-36.257 36.25-36.257 20.016 0 36.249 16.226 36.249 36.257z"></path></svg>
                                    <span class="text-dark">{rentDetails.data[0].washrooms}</span>
                                </li>
                                <li class="list-inline-item mb-2">
                                    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 32 32"> <title>তারিখ</title> <path fill="#000000" d="M9 4h2v1h10v-1h2v1h4v22h-22v-22h4v-1zM7 7v2h18v-2h-2v1h-2v-1h-10v1h-2v-1h-2zM7 11v14h18v-14h-18zM13 13h2v2h-2v-2zM17 13h2v2h-2v-2zM21 13h2v2h-2v-2zM9 17h2v2h-2v-2zM13 17h2v2h-2v-2zM17 17h2v2h-2v-2zM21 17h2v2h-2v-2zM9 21h2v2h-2v-2zM13 21h2v2h-2v-2zM17 21h2v2h-2v-2z"></path> </svg>
                                    <span class="text-dark">{rentDetails.data[0].date}</span>
                                </li>
                                <li class="list-inline-item mb-2">
                                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"> <title>বারিন্দা</title> <path d="M3.125 3.125H16.875V16.875H3.125V3.125ZM4.375 4.375V9.375H9.375V4.375H4.375ZM10.625 4.375V9.375H15.625V4.375H10.625ZM4.375 10.625V15.625H9.375V10.625H4.375ZM10.625 10.625V15.625H15.625V10.625H10.625Z" fill="#000000"></path> </svg>
                                    <span class="text-dark">{rentDetails.data[0].veranda}</span>
                                </li>
                                <li class="list-inline-item mb-2">
                                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><title>ফ্ল্যাটের অবস্থান</title><path d="M17.5 2.53937V17.5006H2.5V6.73874L3.2425 6.89499L6.09438 7.46124L9.64938 5.09812L9.86437 4.96124L13.595 5.58624L16.4856 3.32062L17.5 2.53937ZM16.25 5.09749L14.1406 6.73812L13.9256 6.91374L13.6519 6.87437L10.1363 6.28812L6.60125 8.65124L6.38625 8.78812L6.1325 8.72937L3.74938 8.26062V10.8194L6.17125 11.7962L9.64813 9.47187L9.90188 9.31562L10.195 9.41312L13.6131 10.5462L16.25 8.45624V5.09687V5.09749ZM16.25 10.0587L14.1406 11.7387L13.8669 11.9537L13.5544 11.8362L10.1169 10.6837L6.60125 13.0275L6.3275 13.2031L6.015 13.0856L3.74938 12.1869V16.2494H16.2494V10.0581L16.25 10.0587Z" fill="#000000"></path></svg>
                                    <span class="text-dark">ফ্ল্যাটের অবস্থান {rentDetails.data[0].floorno}</span>
                                </li>
                                <li class="list-inline-item">
                                    <svg width="20" height="20"  viewBox="0 0 24 24"><path fill="#000000" d="M23.5,17L18.5,22L15,18.5L16.5,17L18.5,19L22,15.5L23.5,17M12,9A3,3 0 0,1 15,12A3,3 0 0,1 12,15A3,3 0 0,1 9,12A3,3 0 0,1 12,9M12,4.5C17,4.5 21.27,7.61 23,12C22.75,12.65 22.44,13.26 22.08,13.85C21.5,13.5 20.86,13.25 20.18,13.12L20.82,12C19.17,8.64 15.76,6.5 12,6.5C8.24,6.5 4.83,8.64 3.18,12C4.83,15.36 8.24,17.5 12,17.5L13.21,17.43C13.07,17.93 13,18.46 13,19V19.46L12,19.5C7,19.5 2.73,16.39 1,12C2.73,7.61 7,4.5 12,4.5Z"></path></svg>
                                    <span class="text-dark">{rentDetails.data[0].viewcount} বার দেখা হয়েছে</span>
                                </li>
                        </ul>

                        <hr className="my-4 bg-light" />

                        <Row>
                            <Col md={12}>
                                <h2 className="fs-12 text-light">অন্যান্য চার্জ সমূহ</h2>
                                <ul class="list-inline">
                                    <li class="list-inline-item mb-2 fw-re">
                                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <title>বিদ্যুৎ</title>
                                            <path d="M4.25813 1.50372L5.56687 2.81247L4.68812 3.69122L3.37938 2.38247L4.25813 1.50372ZM15.7425 1.50372L16.6212 2.38247L15.3125 3.69122L14.4337 2.81247L15.7425 1.50372ZM10 1.89435C13.0838 1.86497 15.625 4.41122 15.625 7.49997C15.625 9.19122 14.8444 10.6637 13.8087 11.6993C13.035 12.4181 12.5587 13.3412 12.5587 14.2581V15.0006H12.5V17.5006H11.0744C10.8575 17.8737 10.4606 18.1256 10 18.1256C9.53938 18.1256 9.1425 17.8737 8.92563 17.5006H7.5V13.7506C7.37313 13.0525 7.00375 12.3681 6.40625 11.8562C5.01062 10.67 4.17312 8.8281 4.45312 6.79747C4.80375 4.2731 6.82125 2.22497 9.35562 1.93435C9.3625 1.93372 9.36813 1.93497 9.375 1.93435C9.585 1.90872 9.79438 1.89747 10 1.89497V1.89435ZM10 3.14435C9.83875 3.14685 9.67625 3.1631 9.51187 3.18372C7.555 3.40122 5.9575 4.98435 5.68375 6.9531C5.46375 8.5481 6.1225 9.95997 7.22687 10.8987C8.09437 11.6425 8.55437 12.6787 8.69187 13.7506H11.4262C11.5737 12.6306 12.11 11.6043 12.95 10.8206L12.9306 10.8012C13.77 9.96185 14.3763 8.80935 14.3763 7.5006C14.3763 5.08747 12.4169 3.1106 10.0013 3.14497L10 3.14435ZM1.25 7.49997H3.125V8.74997H1.25V7.49997ZM16.875 7.49997H18.75V8.74997H16.875V7.49997ZM4.6875 12.5587L5.56625 13.4375L4.2575 14.7462L3.37875 13.8675L4.6875 12.5587ZM15.3125 12.5587L16.6212 13.8675L15.7425 14.7462L14.4337 13.4375L15.3125 12.5587ZM8.75 15V16.25H11.25V15H8.75Z" fill="#000000"></path>
                                        </svg>
                                        <span class="text-dark">{rentDetails.data[0].electricbill}</span>
                                    </li>
                                    <li class="list-inline-item mb-2 fw-re">
                                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <title>গ্যাস</title>
                                            <path d="M8.35951 1.875H9.16014L9.33576 2.01188C9.33576 2.01188 10.9026 3.27687 12.4608 5.19562C14.0189 7.11437 15.6251 9.71062 15.6251 12.5006C15.6251 13.7369 15.417 15.165 14.4139 16.29C13.5583 17.2494 12.1689 17.8944 10.0776 18.0675C10.0245 18.0719 9.97576 18.0831 9.92139 18.0869C9.74451 18.1044 9.56514 18.1263 9.37451 18.1263C9.31389 18.1263 9.25826 18.1088 9.19889 18.1069C9.11201 18.1081 9.03451 18.1263 8.94514 18.1263C6.90451 18.1263 5.39889 17.4306 4.45264 16.3881C3.50639 15.3456 3.12451 14.0088 3.12451 12.755C3.12451 10.1025 4.36451 7.98625 5.60514 6.29C6.84576 4.59375 8.05451 3.20562 8.24201 2.36437L8.35951 1.875ZM9.06264 3.4375C8.52014 4.60375 7.58389 5.71562 6.62139 7.03125C5.43889 8.6475 4.37514 10.49 4.37514 12.7538C4.37514 13.7506 4.69264 14.7769 5.39076 15.5469C5.53951 15.7106 5.71201 15.855 5.89889 15.9962C5.85014 15.8756 5.79639 15.7519 5.76201 15.625C5.37514 14.1806 5.82389 12.4544 6.99264 10.8788L7.57889 10.0781L8.04764 10.9569C8.36701 11.5538 8.70201 11.7975 8.88764 11.8556C9.07326 11.9137 9.15264 11.895 9.33701 11.68C9.70514 11.2494 10.0501 9.80375 9.39576 7.67625L9.16139 6.87563H10.3726L10.5483 7.09063C10.8908 7.48625 11.2908 8.20313 11.7595 9.21938C12.2283 10.2356 12.7151 11.4969 12.9708 12.7544C13.1945 13.855 13.2683 14.9637 12.9314 15.9381C13.1439 15.7875 13.3264 15.62 13.4783 15.45C14.1845 14.6581 14.377 13.5981 14.377 12.5006C14.377 10.2075 12.957 7.8075 11.4864 5.99688C10.4208 4.685 9.56951 3.8825 9.06451 3.43812L9.06264 3.4375ZM10.977 10.7619C10.8789 11.47 10.6626 12.0675 10.2933 12.5C9.86326 13.0037 9.15326 13.2469 8.51576 13.0469C8.17139 12.9388 7.87514 12.7294 7.59764 12.4413C7.03326 13.5063 6.77014 14.5569 6.97264 15.3125C7.21764 16.2275 7.86701 16.83 9.21889 16.875C9.27264 16.8769 9.31889 16.875 9.37514 16.875C9.59076 16.8681 9.80389 16.8519 10.0001 16.8356C10.0939 16.8244 10.1895 16.8131 10.2739 16.7963C11.0301 16.6469 11.4014 16.2894 11.6414 15.8C11.9608 15.1475 11.9658 14.1244 11.7389 13.0069C11.5826 12.2381 11.2664 11.4956 10.977 10.7606V10.7619Z" fill="#000000"></path>
                                        </svg>
                                        <span class="text-dark">{rentDetails.data[0].gasbill}</span>
                                    </li>
                                    <li class="list-inline-item mb-2 fw-re">
                                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <title>পানি</title>
                                        <path d="M10 2.14874L10.4881 2.73499C10.4881 2.73499 11.7375 4.23999 13.0075 6.11374C13.6425 7.05062 14.2963 8.07374 14.785 9.06312C15.2738 10.0525 15.625 10.9987 15.625 11.8756C15.625 14.9662 13.0906 17.5006 10 17.5006C6.90937 17.5006 4.375 14.9662 4.375 11.8756C4.375 10.9987 4.72625 10.0525 5.215 9.06312C5.70375 8.07374 6.3575 7.05062 6.9925 6.11374C8.2625 4.23999 9.51187 2.73499 9.51187 2.73499L10 2.14874ZM10 4.15999C9.65 4.59062 8.99688 5.35749 8.0075 6.81624C7.3925 7.72312 6.79625 8.71999 6.3475 9.62874C5.89875 10.5375 5.625 11.3769 5.625 11.875C5.625 14.2844 7.59062 16.25 10 16.25C12.4094 16.25 14.375 14.2844 14.375 11.875C14.375 11.3769 14.1012 10.5381 13.6525 9.62874C13.2037 8.71937 12.6075 7.72312 11.9925 6.81624C11.0037 5.35749 10.3506 4.59062 10 4.15999V4.15999ZM6.875 11.875H8.125C8.125 12.9094 8.96563 13.75 10 13.75V15C8.28438 15 6.875 13.5906 6.875 11.875Z" fill="#000000"></path>
                                    </svg>
                                        <span class="text-dark">{rentDetails.data[0].waterbill}</span>
                                    </li>
                                    <li class="list-inline-item mb-2 fw-re">
                                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <title>সার্ভিস চার্জ</title>
                                            <path d="M8.75 1.875H11.25C11.9331 1.875 12.5 2.44187 12.5 3.125V3.75H14.375V3.125H15.625V3.75H16.875C17.5581 3.75 18.125 4.31687 18.125 5V15C18.125 15.6831 17.5581 16.25 16.875 16.25H3.125C2.44187 16.25 1.875 15.6831 1.875 15V5C1.875 4.31687 2.44187 3.75 3.125 3.75H4.375V3.125H5.625V3.75H7.5V3.125C7.5 2.44187 8.06687 1.875 8.75 1.875ZM8.75 3.125V3.75H11.25V3.125H8.75ZM3.125 5V15H4.375V5.625H5.625V15H14.375V5.625H15.625V15H16.875V5H3.125Z" fill="#000000"></path>
                                        </svg>
                                        <span class="text-dark">{rentDetails.data[0].servicecharge}</span>
                                    </li>
                                </ul>
                                <hr className="my-4 bg-light" />
                                <h2 className="fs-12 text-light">অন্যান্য সুবিধা সমূহ</h2>
                                {rentDetails.data[0].facilities.map(item => 
                                    <Card className="facilities d-inline-block me-2 mb-2">
                                        <Card.Body className="d-flex align-items-center">
                                            <Card.Img variant="top" src={item.logoURL}></Card.Img>
                                            <Card.Text>
                                                {item.name} {item.value}
                                            </Card.Text>
                                        </Card.Body>
                                    </Card>
                                )}
                                
                            </Col>
                            <Col md={12}>
                                <hr className="my-4 bg-light" />
                            </Col>
                            

                            <Col md={12}>
                                <p className="pre-line">
                                    {rentDetails.data[0].description}
                                </p>
                            </Col>
                        </Row>

                        <hr className="my-4 bg-light" />

                        <Alert variant="danger">
                            <p className="m-0">
                                কোন ধরনের আর্থিক লেনদেনের সাথে বাড়িবদল.কম সম্পৃক্ত নয়। যেকোন ধরনের আর্থিক লেনদেন এর ক্ষেত্রে ব্যবহারকারীকে যাচাই বাছাই করে লেনদেন করার অনুরোধ করা হচ্ছে। কেউ কোন ব্যাক্তির মাধ্যমে প্রতারিত হয়ে থাকলে এর দায়ভার বাড়িবদল.কম বহন করবে না।
                            </p>
                        </Alert>

                        <hr className="my-4 bg-light" />

                        <div className="d-flex justify-content-between">
                            <div>
                                <span className="rent-cost fw-bold">{rentDetails.data[0].cost} <small>{rentDetails.data[0].cost !== 'আলোচনায়' && rentDetails.data[0].costduration}</small> </span>
                            </div>
                            <div>
                                <Link variant="primary" className="btn-primary rent-phone" to={`tel:${rentDetails.data[0].phone.slice(2)}`}>
                                    <svg className="icon me-2" height="20" viewBox="0 0 20 30" fill="none" xmlns="http://www.w3.org/2000/svg"><title>phone</title><path d="M3.75 0H16.25C18.3062 0 20 1.69375 20 3.75V26.25C20 28.3062 18.3062 30 16.25 30H3.75C1.69375 30 0 28.3062 0 26.25V3.75C0 1.69375 1.69375 0 3.75 0ZM3.75 2.5C3.05625 2.5 2.5 3.05625 2.5 3.75V26.25C2.5 26.9438 3.05625 27.5 3.75 27.5H16.25C16.9438 27.5 17.5 26.9438 17.5 26.25V3.75C17.5 3.05625 16.9438 2.5 16.25 2.5H3.75ZM10 23.75C10.69 23.75 11.25 24.31 11.25 25C11.25 25.69 10.69 26.25 10 26.25C9.31 26.25 8.75 25.69 8.75 25C8.75 24.31 9.31 23.75 10 23.75Z" fill="white"></path></svg>
                                    {/* ফোন করুন */}
                                    {rentDetails.data[0].phone.slice(2)}
                                    
                                </Link>
                            </div>
                        </div>

                        <div className="mb-5"></div>
                    </div>
                </Col>
            </Row>
        </Container>
                {/* <div className="d-flex justify-content-between align-items-center w-100 rent-summary py-2 position-fixed shadow px-5">
                    <div><span className="rent-cost fw-bold">{rentDetails.data[0].cost} <small>{rentDetails.data[0].cost !== 'আলোচনায়' && rentDetails.data[0].costduration}</small> </span></div>
                    <div>
                        <Link variant="primary" className="btn-primary rent-phone" to={`tel:${rentDetails.data[0].phone.slice(2)}`}>
                            {rentDetails.data[0].phone.slice(2)}
                        </Link>
                    </div>
                </div> */}

                
        </> ) : (
            <div className="d-flex align-items-center justify-content-center">
                <DetailsLoader />
                {/* <Spinner className="spinner-fixed" animation="border" role="status" size="lg" color="#006666">
                    <span className="visually-hidden">Loading...</span>
                </Spinner> */}
            </div>
        )
        }
        </>
  );
}

export default RentDetails;
